import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { ElementName, IconType } from '../../../../../constants';
import { useFlexibleUiContext } from '../../../../../state/flexible-ui-context';
import { BaseBadgeElement, toBadgeProps } from '../common';
var ProgrammingLanguageElement = function ProgrammingLanguageElement(props) {
  var context = useFlexibleUiContext();
  var data = context ? toBadgeProps(context.programmingLanguage) : null;
  return data ? /*#__PURE__*/React.createElement(BaseBadgeElement, _extends({
    icon: IconType.ProgrammingLanguage
  }, data, props, {
    name: ElementName.ProgrammingLanguage
  })) : null;
};
export default ProgrammingLanguageElement;